<template>
  <footer id="primary-footer">
    <div class="footer__wrapper">
      <nav class="footer-menus">
        <div class="footer-menus__container">
          <primary-footer-menu v-for="(primaryFooter, index) in footerPrimaryMenuItem" 
            :key="index"
            :index="index" 
            :primaryFooter="primaryFooter"
            :showAllPrimaryFooterMenus="showAllPrimaryFooterMenus"
            :windowWidth="windowWidth"/>
        </div>
      </nav>
    </div>
    <img v-if="site.footerBackgroundImage"
      :src="site.footerBackgroundImage.imageMedia.file.url" 
      loading="lazy"
      :alt="site.footerBackgroundImage.altText" 
      class="primary-footer--background"/>
  </footer>
</template>

<script>
import { mapState } from "vuex"
import PrimaryFooterMenu from "@/components/layout/PrimaryFooterMenu"

export default {
  name: 'primary-footer',
  components: {
    PrimaryFooterMenu
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      showAllPrimaryFooterMenus: false
    }
  },
  mounted() {
    this.showPrimaryMenusCheck();

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  watch: {
    windowWidth() {
      this.showPrimaryMenusCheck();
    }
  },
  computed: {
    ...mapState(['site', 'footerPrimaryMenuItem'])
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    showPrimaryMenusCheck() {
      if(this.windowWidth >= 1024) {
        this.showAllPrimaryFooterMenus = true
      } else {
        this.showAllPrimaryFooterMenus = false
      }
    }
  },
}
</script>